import {
  PackageThumbnail,
  UserListeningPackagesResponse,
} from '../common/services/package/package.model';
import UtilService from '../common/services/util.service';
import PackageService from '../common/services/package/package.service';
import GlobalSpinnerService from '../common/services/spinner/global-spinner.service';
import { TbasService } from '../buy/services/tbas.services';

export default function($stateProvider) {
  'ngInject';
  let data: PackageThumbnail[] = [];
  let index: number;
  let userListeningPackagesResponse: UserListeningPackagesResponse;

  $stateProvider.state('manageSubscription', {
    component: 'fizyPaycellManageSubscription',
    parent: 'mainWrapper',
    resolve: {
      packet: [
        '$stateParams',
        '$q',
        'packageService',
        'globalSpinner',
        (
          $stateParams,
          $q,
          packageService: PackageService,
          globalSpinner: GlobalSpinnerService
        ) => {
          if (!$stateParams.packetId) {
            return $q.reject('Package not found');
          }

          globalSpinner.start();

          return packageService
            .getPackage()
            .then(packages =>
              $q.resolve(
                packages[
                  UtilService.getElementIndexById(
                    packages,
                    $stateParams.packetId
                  )
                ]
              )
            )
            .catch(() => $q.reject('Package not found'))
            .finally(() => globalSpinner.stop());
        }
      ],
      invoice: [
        '$q',
        'tbasService',
        'globalSpinner',
        ($q, tbasService: TbasService, globalSpinner: GlobalSpinnerService) => {
          globalSpinner.start();
          return tbasService
            .getInvoiceAddressInfo()
            .catch((/*error*/) => $q.resolve())
            .finally(() => globalSpinner.stop());
        }
      ]
    },
    url: '/manage-subscription/:packetId'
  });
}



// WEBPACK FOOTER //
// ./src/app/manage-subscription/manage-subscription.routes.ts